module.exports = __webpack_public_path__ + "img/saishianpai-icon-5.81b86d7d.png";